/**
* Budget validation
*/

const orderBudget = () => {
  const inputField = document.querySelector('.is-budget');
  if (!inputField) return
  const submitBtn = document.querySelector('.js-order-submit-btn')
  const input: any = inputField.querySelector('input[type="text"]');
  const error = inputField.querySelector('.form__error');
  const errorMsg = "半角数字のみでご入力ください。";

  if (!input || !error || !submitBtn) return;
  submitBtn.addEventListener("click", (e) => {
    if (input.value == "") {
      error.classList.add("show");
      error.innerHTML = errorMsg;
    }
  })

  const regex = /^[,0-9]+$/;
  input.addEventListener("keyup", (e: any) => {
    if (!regex.test(input.value)) {
      error.classList.add("show");
      error.innerHTML = errorMsg

      if(input.value == "") {
        error.classList.add("show");
        error.innerHTML = errorMsg;
      }
    }
    else {
      error.classList.remove("show");
    }
  })

  input.addEventListener("blur", () => {
    if (!regex.test(input.value)) {
      error.classList.add("show");
      error.innerHTML = errorMsg

      if(input.value == "") {
        error.classList.add("show");
        error.innerHTML = errorMsg;
      }
    }
    else {
      error.classList.remove("show");

      let val = input.value;
      val = val.replace(/\D/g, "");
      val = val.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      input.value = val
    }
  })
}

export default orderBudget
